// extracted by mini-css-extract-plugin
export default {"keyboard_toggle":"KeyboardToggle_keyboard_toggle__hs88+","icon":"KeyboardToggle_icon__g+N0J"};